<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="渠道审核"
    width="500px"
    :before-close="handleClose"
    @close="handleDialogClose">
    <div class="audit-dialog-content">
      <div class="audit-form">
        <div class="audit-result-btns">
          <div class="result-btn pass" :class="{ 'active': auditForm.status === 1 }" @click="auditForm.status = 1">
            <i class="el-icon-success"></i>
            <span>通过</span>
          </div>
          <div class="result-btn reject" :class="{ 'active': auditForm.status === 3 }" @click="auditForm.status = 3">
            <i class="el-icon-error"></i>
            <span>拒绝</span>
          </div>
        </div>
        <div class="audit-remark">
          <div class="remark-label">
            审核备注
            <span v-if="auditForm.status === 3" class="required">*</span>
          </div>
          <el-input
            type="textarea"
            v-model="auditForm.remark"
            :rows="3"
            :placeholder="auditForm.status === 3 ? '请填写拒绝原因（必填）' : '备注信息（可选）'"
            maxlength="200"
            show-word-limit>
          </el-input>
        </div>
        <div class="quick-reject" v-if="auditForm.status === 3">
          <span class="quick-label">快捷原因：</span>
          <el-tag
            v-for="reason in quickRejectReasons"
            :key="reason"
            size="small"
            class="quick-tag"
            @click="auditForm.remark = reason">
            {{ reason }}
          </el-tag>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">提交审核</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AuditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    channelId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      auditForm: {
        status: 1,
        remark: ''
      },
      submitLoading: false,
      // 快捷拒绝原因
      quickRejectReasons: [
        '身份证照片模糊',
        '身份证信息与填写不符',
        '人脸识别未通过',
        '资料不完整',
        '工作区域不在服务范围'
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        // 打开时重置表单
        this.auditForm = {
          status: 1,
          remark: ''
        }
      }
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    handleClose() {
      if (this.auditForm.remark) {
        this.$confirm('审核内容未提交，确定关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.dialogVisible = false
        }).catch(() => {})
      } else {
        this.dialogVisible = false
      }
    },
    handleDialogClose() {
      // 弹框关闭时重置表单
      this.auditForm = {
        status: 1,
        remark: ''
      }
      this.submitLoading = false
    },
    /**
     * 提交审核
     * 作者：孙艺
     */
    async handleSubmit() {
      if (this.auditForm.status === 3 && !this.auditForm.remark) {
        this.$message.warning('请填写拒绝原因')
        return
      }

      this.submitLoading = true
      try {
        // auditForm.status: 1-通过, 3-拒绝
        // 后端接口需要：status: 1-通过, 3-拒绝
        const res = await this.$axios.post('/api/v1/channel/audit', {
          id: this.channelId,
          status: this.auditForm.status,
          auditRemark: this.auditForm.remark
        })

        if (res && res.code === 1) {
          this.$message.success(this.auditForm.status === 1 ? '审核通过' : '已拒绝该申请')
          this.dialogVisible = false
          this.$emit('success')
        } else {
          this.$message.error(res.msg || '审核失败')
        }
      } catch (error) {
        this.$message.error('审核失败')
      } finally {
        this.submitLoading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.audit-dialog-content {
  padding: 20px 0;
}

.audit-form {
  .audit-result-btns {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;

    .result-btn {
      flex: 1;
      padding: 20px;
      border-radius: 8px;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;
      border: 2px solid transparent;

      i {
        font-size: 32px;
        display: block;
        margin-bottom: 8px;
      }

      span {
        font-size: 14px;
        font-weight: 500;
      }

      &.pass {
        background: #67C23A10;
        color: #67C23A;

        &:hover,
        &.active {
          border-color: #67C23A;
          background: #67C23A20;
        }
      }

      &.reject {
        background: #F56C6C10;
        color: #F56C6C;

        &:hover,
        &.active {
          border-color: #F56C6C;
          background: #F56C6C20;
        }
      }
    }
  }

  .audit-remark {
    .remark-label {
      font-size: 13px;
      color: #606266;
      margin-bottom: 8px;

      .required {
        color: #F56C6C;
      }
    }
  }

  .quick-reject {
    margin-top: 12px;

    .quick-label {
      font-size: 12px;
      color: #909399;
      margin-right: 8px;
    }

    .quick-tag {
      margin-right: 8px;
      margin-bottom: 8px;
      cursor: pointer;

      &:hover {
        background: #409EFF;
        color: #fff;
        border-color: #409EFF;
      }
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>

